// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1613":"css/app.6640","7515":"css/admin-app.6640"}[chunkId] + ".css";
};